module.exports = __webpack_public_path__ + "static/media/enterLeft.cb78ddcb.svg";